import React from 'react'
import "./style.scss"
import { Link } from 'react-router-dom'

import iconEbit from '../../assets/imagens/logo-eBit-NielsenCompany.png'
import iconNielsen from '../../assets/imagens/EbitNielsen-Logo2020-BkBlack.9a629f41.png'

const Footer = () => {
  return (
    <>
      <footer className="py-8 py-md-11 bg-dark footerEbit">
        <div className="container">
          <div className="row">
            <div className="col-12 col-md-4 col-lg-3">
              <img src={iconNielsen} alt="..." className="logo-footer footer-brand img-fluid mb-2" />
              <p className=" mb-2">
              </p>
              <ul className="list-unstyled list-inline list-social mb-6 mb-md-0">
                <li className="list-inline-item list-social-item mr-3">
                  <a href="https://www.facebook.com/oficialebit" className="text-decoration-none">
                    <i className="fa fa-facebook-square list-social-icon icon-social-media"></i>
                  </a>
                </li>
                <li className="list-inline-item list-social-item mr-3">
                  <a href="href=https://www.linkedin.com/company/ebit" className="text-decoration-none">
                    <i className="fa fa-linkedin-square list-social-icon icon-social-media"></i>
                  </a>
                </li>
                <li className="list-inline-item list-social-item mr-3">
                  <a href="https://twitter.com/ebitoficial" className="text-decoration-none">
                    <i className="fa fa-twitter-square list-social-icon icon-social-media"></i>
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md-4 col-lg-2">
              <h6 className="font-weight-bold text-uppercase h6-color">
                A Ebit | Nielsen
            </h6>
              <ul className="list-unstyled text-muted mb-6 mb-md-8 mb-lg-0">
                <li className="">
                  <Link to="/sobre-nos" className="text-reset">
                    Sobre nós
                </Link>
                </li>
                <li className="">
                  <Link to="/reputacao-de-lojas" className="text-reset">
                    Reputação de Lojas
                </Link>
                </li>
                <li className="">
                  <Link to="/medalhas-ebit" className="text-reset">
                    Medalha
                </Link>
                </li>
                <li className="">
                  <a href="https://www.nielsen.com/br/pt/about-us/careers/" target="_blank" className="text-reset">
                    Faça parte da Ebit | Nielsen
                </a>
                </li>
                <li className="">
                  <a href="https://ebit.zendesk.com/hc/pt-br" target="_blank" className="text-reset">
                    Fale conosco
                </a>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md-4 col-lg-2">
              <h6 className="font-weight-bold text-uppercase h6-color">
                Consumidor
            </h6>
              <ul className="list-unstyled text-muted mb-6 mb-md-8 mb-lg-0">
                <li className="">
                  <a href="https://company.ebit.com.br/termo-cadastro" target="_blank" className="text-reset">
                    Termo de cadastro
                </a>
                </li>
                <li className="">
                  <a href="https://company.ebit.com.br/user/login" target="_blank" className="text-reset">
                    Portal do usuário
                </a>
                </li>

                <li className="">
                  <Link to="/consumidor" className="text-reset">
                    Sorteios Ebit | Nielsen
                </Link>
                </li>
                <li className="">
                  <a href="https://company.ebit.com.br/politica-de-privacidade" className="text-reset">
                    Política de Privacidade
                </a>
                </li>

              </ul>
            </div>

            <div className="col-6 col-md-4 offset-md-4 col-lg-2 offset-lg-0">
              <h6 className="font-weight-bold text-uppercase h6-color">
                Empresa
            </h6>
              <ul className="list-unstyled text-muted mb-0">
                <li className="">
                  <a href="https://company.ebit.com.br/termo-lojista" target="_blank" className="text-reset">
                    Termo de Uso lojista
                  </a>
                </li>
                <li className="">
                  <Link to="/lojista" className="text-reset">
                    Lojista
                  </Link>
                </li>  
                <li className="">
                  <a href="https://company.ebit.com.br/cadastro-de-loja" target="_blank" className="text-reset">
                    Seja conveniado
                  </a>
                </li>  
                <li className="">
                  <a href="https://company.ebit.com.br/developer" target="_blank" className="text-reset">
                    Como implementar nossa Tag
                  </a>
                </li>        
              </ul>
            </div>           
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer